import Vue from "vue";

export default {
  admins(state, admins) {
    state.admins.list = admins;
  },
  admin(state, admin) {
    console.log(admin);
    const index = state.admins.list.findIndex(u => u.id === admin.id);
    console.log(index);
    if (index >= 0) {
      console.log(admin);
      const updatedAdmin = { ...state.admins.list[index], permissions: admin.permissions };
      Vue.set(state.admins.list, index, updatedAdmin);
    } else {
      state.admins.list.push(admin);
    };
  },
  adminsCounter(state, total) {
    state.admins.total = total;
  }
};
